var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#F6F8FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#E2E8F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.161 11.62C14.001 11.62 14.7383 11.7647 15.373 12.054C16.0077 12.3433 16.549 12.7727 16.997 13.342L15.919 14.588C15.5363 14.1027 15.1163 13.748 14.659 13.524C14.211 13.2907 13.6883 13.174 13.091 13.174C12.699 13.174 12.3723 13.2253 12.111 13.328C11.859 13.4307 11.6723 13.566 11.551 13.734C11.439 13.902 11.383 14.0887 11.383 14.294C11.383 14.546 11.481 14.7607 11.677 14.938C11.873 15.106 12.209 15.246 12.685 15.358L14.407 15.75C15.3217 15.9553 15.975 16.2633 16.367 16.674C16.7683 17.0753 16.969 17.598 16.969 18.242C16.969 18.8487 16.8103 19.3713 16.493 19.81C16.1757 20.2393 15.7323 20.5707 15.163 20.804C14.5937 21.028 13.9403 21.14 13.203 21.14C12.559 21.14 11.9663 21.0653 11.425 20.916C10.893 20.7573 10.417 20.5427 9.99701 20.272C9.57701 20.0013 9.22701 19.6887 8.94701 19.334L10.039 18.032C10.2537 18.3307 10.5197 18.5967 10.837 18.83C11.1543 19.0633 11.5137 19.25 11.915 19.39C12.3257 19.5207 12.755 19.586 13.203 19.586C13.5857 19.586 13.9077 19.544 14.169 19.46C14.4397 19.3667 14.6403 19.2407 14.771 19.082C14.911 18.914 14.981 18.7133 14.981 18.48C14.981 18.2373 14.897 18.032 14.729 17.864C14.5703 17.6867 14.2717 17.5513 13.833 17.458L11.957 17.038C11.4157 16.9073 10.949 16.7393 10.557 16.534C10.1743 16.3193 9.88034 16.0487 9.67501 15.722C9.47901 15.386 9.38101 14.9893 9.38101 14.532C9.38101 13.9813 9.53034 13.4867 9.82901 13.048C10.1277 12.6093 10.557 12.264 11.117 12.012C11.6863 11.7507 12.3677 11.62 13.161 11.62ZM20.3508 21V15.148C20.3508 14.9333 20.3508 14.714 20.3508 14.49C20.3601 14.2567 20.3694 14.0187 20.3788 13.776C20.0614 14.0653 19.7068 14.3173 19.3148 14.532C18.9228 14.7467 18.5214 14.896 18.1108 14.98L17.8588 13.356C18.0734 13.3373 18.3114 13.2767 18.5728 13.174C18.8434 13.062 19.1141 12.9313 19.3848 12.782C19.6648 12.6233 19.9168 12.46 20.1408 12.292C20.3741 12.1147 20.5514 11.9373 20.6728 11.76H22.2408V21H20.3508Z",
    fill: "#0075FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.64044521d4e9f83100dc799bd553d614.svg";
export { ForwardRef as ReactComponent };